/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import { Typography } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Items from './items';

const drawerWidth = 240;

const styles = (theme) => ({
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${theme.spacing(1)}px`,
    transition: theme.transitions.create('justifyContent', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    ...theme.mixins.toolbar,
  },
  toolbarIconOpen: {
    justifyContent: 'flex-end',
  },
  toolbarIconClose: {
    justifyContent: 'center',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
});

const Menu = ({ classes, isOpen, toggleDrawer, scopes }) => (
  <Drawer
    variant='permanent'
    classes={{
      paper: classNames(
        classes.drawerPaper,
        !isOpen && classes.drawerPaperClose,
      ),
    }}
    open={isOpen}
  >
    <div
      className={classNames(
        classes.toolbarIcon,
        isOpen && classes.toolbarIconOpen,
        !isOpen && classes.toolbarIconClose,
      )}
    >
      <Typography variant='subtitle1'>Vergabekommission</Typography>
      <IconButton onClick={toggleDrawer}>
        {isOpen && <ChevronLeftIcon />}
        {!isOpen && <ChevronRightIcon />}
      </IconButton>
    </div>
    <Divider />
    <List>
      <Items scopes={scopes} />
    </List>
  </Drawer>
);

Menu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
};

export default withStyles(styles)(Menu);
